module.exports = __webpack_public_path__ + "static/media/wn_2introIMG_3543.0032d361.jpg";